import {
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLList,
  GraphQLBoolean
} from 'graphql'

export type MetadataFieldType = 'STRING' | 'NUMERIC' | 'PERSON_OF_CONTACT'

export type MetadataSubfieldType = 'CONTACT_NAME' | 'PHONE' | 'EMAIL'

export interface MetadataValue {
  readonly name: string
  readonly value: string
  readonly unique: boolean
  readonly type: MetadataFieldType
  readonly subfields?: Array<{
    readonly name: string
    readonly value: string
    readonly unique: boolean
    readonly type: MetadataSubfieldType
    readonly isOverriddenByUser: boolean
  }>
  readonly isOverriddenByUser: boolean
}

export const metadataValueType = new GraphQLObjectType({
  name: 'MetadataValue',
  description: 'A value of a custom metadata field',
  fields: () => ({
    name: {
      description: 'A displayable label for the field',
      type: new GraphQLNonNull(GraphQLString)
    },
    value: {
      description: 'A displayable value for the field',
      type: new GraphQLNonNull(GraphQLString)
    },
    unique: {
      description: 'Indicates if this subfield is unique',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    type: {
      description: 'Field type',
      type: new GraphQLNonNull(GraphQLString)
    },
    subfields: {
      description: 'An optional list of subfield values',
      type: new GraphQLList(
        new GraphQLNonNull(
          new GraphQLObjectType({
            name: 'MetadataSubvalue',
            description: 'A value of a custom metadata subfield',
            fields: () => ({
              name: {
                description: 'A displayable label for the subfield',
                type: new GraphQLNonNull(GraphQLString)
              },
              value: {
                description: 'A displayable value for the subfield',
                type: new GraphQLNonNull(GraphQLString)
              },
              unique: {
                description: 'Indicates if this subfield is unique',
                type: new GraphQLNonNull(GraphQLBoolean)
              },
              type: {
                description: 'Subfield type',
                type: new GraphQLNonNull(GraphQLString)
              },
              isOverriddenByUser: {
                description: 'Indicates if this subfield value is overridden',
                type: new GraphQLNonNull(GraphQLBoolean)
              }
            })
          })
        )
      )
    },
    isOverriddenByUser: {
      description: 'Indicates if this field value is overridden',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})
